
export const roFlag = () => {
    return (

        <svg width={"100%"} height={"100%"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2"><path fill="#002B7F" d="M0 0h1v2H0z" /><path fill="#FCD116" d="M1 0h1v2H1z" /><path fill="#CE1126" d="M2 0h1v2H2z" /></svg>
    );
};